import React, { ReactNode } from 'react';

type AriaHiddenImage = {
  hideAdjacentImageLink?: boolean;
  children: any;
};

/**
 * Sometimes, we hide content from being read twice by screen readers.
 * Mostly in teaser lists, when images and headlines are both linked to the article.
 * This functions adds aria-hidden="true" to the node that we want to hide.
 */
export function AriaHiddenImage({ hideAdjacentImageLink, children }: AriaHiddenImage) {
  function isReactElement(node: ReactNode): boolean {
    return React.isValidElement(node) && typeof node.type === 'string';
  }

  if (hideAdjacentImageLink === true) {
    let additionalProps: Record<string, boolean | string> = {};

    if (isReactElement(children)) {
      additionalProps = { 'aria-hidden': 'true' };
    } else {
      additionalProps.ariaHidden = true;
    }

    return React.cloneElement(children, { ...additionalProps });
  }

  return children;
}
